import React from "react";
import Layout from "../components/Layout";
import { IoRocket, IoSparkles } from "react-icons/io5";
import { FaPaperPlane } from "react-icons/fa";
import { MoonLoader } from "react-spinners";
import { graphql } from "gatsby";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

export const Head = () => <title>Reflekt Lab - Contact</title>;

const ContactPage = () => {
  const { t } = useTranslation();
  const [messageSent, setMessageSent] = React.useState(false);
  const [sendingMessage, setSendingMessage] = React.useState(false);
  const [formData, setFormData] = React.useState({
    first_name: "",
    last_name: "",
    email_address: "",
    company: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   console.log("Form data", formData);
  //   setSendingMessage(true);
  //   setTimeout(() => {
  //     setSendingMessage(false);
  //     setMessageSent(true);
  //   }, 4000);
  //   setFormData({
  //     first_name: "",
  //     last_name: "",
  //     email_address: "",
  //     company: "",
  //     message: "",
  //   });
  // };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(formData);

    setSendingMessage(true);
    try {
      const response = await fetch(
        "https://rflkt--sales-assistant-helpers.modal.run/lp-form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.status === 200) {
        setFormData({
          first_name: "",
          last_name: "",
          email_address: "",
          company: "",
          message: "",
        });
        setSendingMessage(false);
        setMessageSent(true);
      } else if (response.status === 500) {
        alert("Server error, form submission failed.");
      } else if (response.status === 422) {
        const errorData = await response.json();
        alert(`Form submission failed: ${errorData.message}`);
      } else {
        alert("Form submission failed.");
      }
    } catch (error) {
      console.error("Form submission failed.", error);
    }
  };

  return (
    <Layout>
      <div className="bg-bg bg-center bg-cover w-full h-full md:h-screen flex flex-col md:flex-row justify-between items-center px-4 md:px-32 sm:py-16 gap-8 sm:gap-16 text-gray-1">
        <div className="flex flex-col gap-8 justify-center sm:items-start mt-8 sm:mt-0">
          <div className="flex flex-col gap-2">
            <h1 className="text-3xl sm:text-4xl font-bold">
              <Trans>header</Trans>
            </h1>
            <p className="font-semibold">
              <Trans>subtitle</Trans>
            </p>
          </div>
          <div className="flex flex-col items-center sm:items-start gap-4">
            <div className="flex gap-4 items-center">
              <IoSparkles />
              <span>
                <Trans>understand</Trans>
              </span>
            </div>
            <div className="flex gap-4 items-center">
              <IoRocket />
              <span>
                <Trans>learn</Trans>
              </span>
            </div>
          </div>
        </div>

        {/* form */}
        <div className="w-full md:w-3/5 border border-gray-3 py-10 px-8 rounded-lg shadow mb-8">
          {sendingMessage && (
            <div className="flex flex-col items-center gap-4 text-gray-1">
              <MoonLoader size={20} color="#1F2933" />
              <h2 className="text-2xl font-bold">
                <Trans>sending</Trans>
              </h2>
              <p className="text-base text-center">
                <Trans>please_wait</Trans>
              </p>
            </div>
          )}
          {messageSent ? (
            <div className="flex flex-col items-center gap-4 text-gray-1">
              <FaPaperPlane className="text-gray-1 size-8" />
              <h2 className="text-2xl font-bold">
                <Trans>sent</Trans>
              </h2>
              <p className="text-base text-center">
                <Trans>thanks</Trans>
              </p>
            </div>
          ) : (
            !sendingMessage && (
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                  <div className="sm:col-span-3">
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-medium leading-6 text-gray-2"
                    >
                      <Trans>form_first_name</Trans>
                    </label>
                    <div className="mt-2">
                      <input
                        type="text"
                        name="first_name"
                        id="firstName"
                        autoComplete="given-name"
                        className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-2 shadow-sm ring-1 ring-inset ring-gray-3 placeholder:text-gray-3 focus:ring-2 focus:ring-inset focus:ring-gray-3 sm:text-sm sm:leading-6"
                        aria-label="First name"
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label
                      htmlFor="lastName"
                      className="block text-sm font-medium leading-6 text-gray-2"
                    >
                      <Trans>form_last_name</Trans>
                    </label>
                    <div className="mt-2">
                      <input
                        type="text"
                        name="last_name"
                        id="lastName"
                        autoComplete="family-name"
                        className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-2 shadow-sm ring-1 ring-inset ring-gray-3 placeholder:text-gray-3 focus:ring-2 focus:ring-inset focus:ring-gray-3 sm:text-sm sm:leading-6"
                        aria-label="Last name"
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium leading-6 text-gray-2"
                    >
                      <Trans>form_email</Trans>
                    </label>
                    <div className="mt-2">
                      <input
                        id="email"
                        name="email_address"
                        type="email"
                        autoComplete="email"
                        className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-2 shadow-sm ring-1 ring-inset ring-gray-3 placeholder:text-gray-3 focus:ring-2 focus:ring-inset focus:ring-gray-3 sm:text-sm sm:leading-6"
                        aria-label="Email address"
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label
                      htmlFor="company"
                      className="block text-sm font-medium leading-6 text-gray-2"
                    >
                      <Trans>form_company</Trans>
                    </label>
                    <div className="mt-2">
                      <input
                        type="text"
                        name="company"
                        id="company"
                        autoComplete="company"
                        className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-2 shadow-sm ring-1 ring-inset ring-gray-3 placeholder:text-gray-3 focus:ring-2 focus:ring-inset focus:ring-gray-3 sm:text-sm sm:leading-6"
                        aria-label="Company"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-span-full">
                    <label
                      htmlFor="about"
                      className="block text-sm font-medium leading-6 text-gray-2"
                    >
                      <Trans>form_message</Trans>
                    </label>
                    <div className="mt-2">
                      <textarea
                        id="about"
                        name="message"
                        rows={3}
                        value={formData.message}
                        onChange={handleChange}
                        className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-2 shadow-sm ring-1 ring-inset ring-gray-3 placeholder:text-gray-3 focus:ring-2 focus:ring-inset focus:ring-gray-3 sm:text-sm sm:leading-6"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex items-center justify-start gap-x-6">
                  <button
                    type="submit"
                    className="px-4 py-2 bg-light-blue rounded-full text-white font-bold hover:bg-dark-blue hover:-translate-y-1 hover:shadow-md w-fit transition ease-in duration-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-light-blue"
                  >
                    <Trans>button_send</Trans>
                  </button>
                </div>
              </form>
            )
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: {
        ns: { in: ["contact", "common", "home_page"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
